import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledRide, ScheduledRideInput } from '@/models/scheduledRide';

export const createWillCallRide = async (data: ScheduledRideInput): Promise<ScheduledRide> => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation CreateWillCallRide($data: ScheduledRideInputType!) {
        createWillCallRide(data: $data) {
          id
        }
      }
    `),
  });

  return response.data?.createWillCallRide!;
};
